<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner :slider="slider"/>
    <FuncShow :funInfo="funInfo" style="background: #F4F7FF; ">
    </FuncShow>
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncShow from '../widgets/func-show'
import ContactFloat from '../widgets/contact-float.vue'
export default {
  components: {
    Navigator,
    ContactFloat,
    FuncShow,
    SliderBanner,
    Footer
  },
  data() {
    return {
      slider: {
        image: require('@/assets/images/index/chat-gpt/phone.png'),
        title: '人工智能ChatGPT',
        desc: "人工智能协助您提高生活效率，解决写作、制图等问题，还能和你聊天"
      },
      funInfo: {
        title: '人工智能ChatGPT',
        list: [
          {
            title: '智能写作',
            img: require('@/assets/images/index/chat-gpt/img2.png'),
            text: '向人工智能描述想要写作的类型和方向，每次它都会为您编写出不一样的文章'
          },
          {
            title: '智能绘图',
            img: require('@/assets/images/index/chat-gpt/img3.png'),
            text: '用简单的话语描述一个场景，人工智能将为您合成一副美丽、新颖的画'
          },
          {
            title: '智能聊天',
            img: require('@/assets/images/index/chat-gpt/img4.png'),
            text: '人工智能可以觉察到您的情绪，和你一起聊天，为你带来欢乐'
          },
          {
            title: '付费升级',
            img: require('@/assets/images/index/chat-gpt/img5.png'),
            text: '付费升级可以获得更多聊天次数包、写作次数包、制图次数包和语音次数包，为您解决更多生活问题 '
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
